import { accessTokenInterceptor } from '@teko/auth';
import {
  ICreateProductReviewPayload,
  ICreateProductReviewResponse,
  ICreateStudentInfoPayload,
  ICreateStudentInfoResponse,
  IGetCustomerProfileRequest,
  IGetCustomerProfileResponse,
  IGetProductReviewResponse,
  IGetProductReviewsParams,
  ISendOTPRequest,
  ISendOrVerifyOTPResponse,
  IVerifyOTPRequest,
} from 'types';
import { consumerBffApi } from './clients';

export const getProductReviews = async (
  productId: number,
  params: IGetProductReviewsParams,
): Promise<IGetProductReviewResponse> => {
  const { data } = await consumerBffApi.get(
    `api/v1/products/${productId}/reviews`,
    { params: { ...params } },
  );
  return data.data;
};

export const createProductReview = async (
  productId: number,
  payload: ICreateProductReviewPayload,
): Promise<ICreateProductReviewResponse> => {
  consumerBffApi.addInterceptor(accessTokenInterceptor);
  const res = await consumerBffApi.post(
    `api/v1/products/${productId}/reviews`,
    payload,
  );
  return res.data;
};

export const getCustomerProfile = async (
  params: IGetCustomerProfileRequest,
): Promise<IGetCustomerProfileResponse> => {
  consumerBffApi.addInterceptor(accessTokenInterceptor);
  const res = await consumerBffApi.get(`api/v1/profiles`, {
    params: { ...params },
  });
  return res.data;
};

export const createStudentInfo = async (
  profileId: string,
  payload: ICreateStudentInfoPayload,
  language?: string,
): Promise<ICreateStudentInfoResponse> => {
  consumerBffApi.addInterceptor(accessTokenInterceptor);
  const res = await consumerBffApi.post(
    `api/v1/profiles/${profileId}/student-info`,
    payload,
    {
      headers: {
        'Accept-Language': language || '*',
      },
    },
  );
  return res.data;
};

export const sendOTPToEmail = async (
  payload: ISendOTPRequest,
): Promise<ISendOrVerifyOTPResponse> => {
  consumerBffApi.addInterceptor(accessTokenInterceptor);
  const res = await consumerBffApi.post(
    `api/v1/profiles/otp/send-email`,
    payload,
  );
  return res.data;
};

export const verifyOTP = async (
  payload: IVerifyOTPRequest,
): Promise<ISendOrVerifyOTPResponse> => {
  consumerBffApi.addInterceptor(accessTokenInterceptor);
  const res = await consumerBffApi.post(
    `api/v1/profiles/otp/verify-email`,
    payload,
  );
  return res.data;
};
